<ng-container *ngFor="let organizationLink of organizationLinkUrlParams; let isLast = last; index as j">
  <span *ngIf="organizationLink.isCustom" [attr.data-test-id]="'organizationItem' + '-' + j">
    {{ organizationLink.organization_name | translate }}{{ isLast ? '' : ', ' }}
  </span>
  <a
    *ngIf="!organizationLink.isCustom"
    [routerLink]="organizationLink.url"
    [queryParams]="organizationLink.params"
    [attr.data-test-id]="'organizationItem' + '-' + j"
    class="organization-link"
  >
    {{ organizationLink.organization_name | translate }}{{ isLast ? '' : ', ' }}
  </a>
</ng-container>
